import moment from 'moment'
import { requireBillTypes } from '@/core/services/store/modules/einvoice/einvoice.contract'

export function parseFilterDate(value) {
  if (!value) return null

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value
  }

  if (typeof value === 'string') {
    const parsed = moment(
      value,
      ['DD/MM/YYYY', 'DD/MM/YYYY HH:mm', 'YYYY-MM-DD', moment.ISO_8601],
      true,
    )
    return parsed.isValid() ? parsed.toDate() : null
  }

  return null
}

export function formatFilterDate(value) {
  const parsed = parseFilterDate(value)
  if (!parsed) return undefined

  return moment(parsed).format('YYYY-MM-DD')
}

export function isFilterDateRangeInvalid(dateFrom, dateTo) {
  const from = parseFilterDate(dateFrom)
  const to = parseFilterDate(dateTo)

  if (!from || !to) return false
  return from.getTime() > to.getTime()
}

function formatDraftDate(value) {
  return value ? moment(parseFilterDate(value)).format('DD/MM/YYYY') : ''
}

export function buildFilterDraft(filterValue = {}) {
  return {
    billTypes: Array.isArray(filterValue.billTypes) ? [...filterValue.billTypes] : undefined,
    keyword: typeof filterValue.keyword === 'string' ? filterValue.keyword : '',
    buyerTaxCode: typeof filterValue.buyerTaxCode === 'string' ? filterValue.buyerTaxCode : '',
    codeShip: typeof filterValue.codeShip === 'string' ? filterValue.codeShip : '',
    status: filterValue.status || null,
    storeIds: Array.isArray(filterValue.storeIds) ? [...filterValue.storeIds] : [],
    dateFrom: formatDraftDate(filterValue.dateFrom),
    dateTo: formatDraftDate(filterValue.dateTo),
    issueDateFrom: formatDraftDate(filterValue.issueDateFrom),
    issueDateTo: formatDraftDate(filterValue.issueDateTo),
  }
}

export function buildAppliedFilterPayload(filterValue = {}) {
  const storeIds = Array.isArray(filterValue.storeIds) && filterValue.storeIds.length
    ? filterValue.storeIds.filter((id) => id !== null && id !== undefined && id !== '')
    : undefined

  const buyerTaxCode =
    typeof filterValue.buyerTaxCode === 'string' && filterValue.buyerTaxCode.trim()
      ? filterValue.buyerTaxCode.trim()
      : ''

  return {
    billTypes: requireBillTypes(filterValue.billTypes),
    keyword:
      typeof filterValue.keyword === 'string' && filterValue.keyword.trim()
        ? filterValue.keyword.trim()
        : '',
    buyerTaxCode,
    codeShip:
      typeof filterValue.codeShip === 'string' && filterValue.codeShip.trim()
        ? filterValue.codeShip.trim()
        : '',
    status: filterValue.status || undefined,
    storeIds,
    dateFrom: formatFilterDate(filterValue.dateFrom),
    dateTo: formatFilterDate(filterValue.dateTo),
    issueDateFrom: formatFilterDate(filterValue.issueDateFrom),
    issueDateTo: formatFilterDate(filterValue.issueDateTo),
    page: Number.isInteger(filterValue.page) && filterValue.page > 0 ? filterValue.page : 1,
  }
}
